// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-styles-manager .list-buttons button {
    height: 2rem;
    width: 2rem;
}
.network-styles-manager .CodeMirror {
    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color);
    border-radius: var(--bs-border-radius);
}
.network-styles-manager .CodeMirror-scroll {
    max-height: 18rem;
}
.node-fenotypes-container, .relation-fenotypes-container,
.node-genotypes-container, .relation-genotypes-container {
    height: calc(100% - 2.5rem);
}
.network-styles-manager .ui-tabs-panel {
    height: calc(100% - 3rem);
}
.network-styles-manager .tab.ui-tabs-active a {
    color: var(--bs-black);
}
.network-styles-manager .tab a {
    color: var(--bs-gray-300);
}

.popup-window {
    position: absolute;
    background-color: var(--bs-gray-200);
    padding: 0.5rem;
    z-index: 9999;
    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color);
    border-radius: var(--bs-border-radius);
}
.popup-window .no-decoration {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
